<template>
    <div class="login-box" id="login-box-id" :style="loginbox">
        <div class="login-content">
            <div class="login-header">
                <div class="title">会声智达</div>
                <div class="sub-title">言出即文，智达高效，私有化的会议智能革新</div>
            </div>

            <!-- 未配置 -->
            <template v-if="status == 0">
                <div class="login-form">
                    <div class="login-tip">请输入激活码</div>
                    <a-input v-model:value="activationCode" class="activation-code" allowClear placeholder="请在此输入您的激活码" />
                    <a-button class="submit-btn" type="primary" @click="login">立即激活</a-button>
                </div>
            </template>

            <!-- 配置中 -->
            <template v-if="status == 1">
                <div class="login-status">
                    <img class="login-icon rotating" :src="iconConfig" />
                    <div class="login-desc">正在配置中，请稍候...</div>
                </div>
            </template>

            <!-- 配置完成 -->
            <template v-if="status == 2">
                <div class="login-status">
                    <img class="login-icon" :src="iconDone" />
                    <div class="login-desc">配置完成，即将进入系统</div>
                </div>
            </template>
        </div>
    </div>
</template>
<script setup>

import { message } from "ant-design-vue";
import { ref } from "vue";
import { useRouter } from 'vue-router'
import iconDone from '@/assets/images/icon_done.png';
import iconConfig from '@/assets/images/icon_config.png';
import { BASE_URL } from '@/config/api';
const router = useRouter()
const status = ref(0) // 0 未配置 1 配置中 2配置完成
const activationCode = ref()
let loginbox = {
    color: '#fff',
    height: '100%',
    backgroundImage: `url(${require('@/assets/images/login-bg.png')}), linear-gradient(135deg, #246BF0 0%, #1347A2 100%)`,
    backgroundSize: 'cover, cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
};
// 登录
const login = async () => {
    // 校验验证码是否正确
    if (!activationCode.value) {
        message.error('请输入激活码')
        return
    }

    const response = await fetch(`${BASE_URL}/activate`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            code: activationCode.value
        })
    }).catch(() => {

    });
    if (response) {
        const res = await response.json();
        if (res.code != 200) {
            message.error(res.message)
            return
        }
        localStorage.setItem('myPermission', JSON.stringify(res.data))
        status.value = 1
        setTimeout(() => {
            status.value = 2
            setTimeout(() => {
                router.push({ path: '/dashboard' })
            }, 600)
        }, 800)
    }
}

localStorage.removeItem('myPermission')

</script>
<style scoped lang="less">
#login-box-id {
    color: #fff;
    height: 100%;
    background-size: cover, cover;
    background-repeat: no-repeat;
    background-position: center;
    display: flex;
    justify-content: center;
    align-items: center;
}

.login-content {
    width: 450px;
    background: rgba(255, 255, 255, 0.95);
    border-radius: 16px;
    padding: 40px;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
    color: #1E293B;
    animation: slideUp 0.5s ease-out;
}

.login-header {
    text-align: center;
    margin-bottom: 40px;
}

.title {
    font-weight: 800;
    font-size: 28px;
    color: #246BF0;
    margin-bottom: 15px;
    text-shadow: 0 2px 4px rgba(36, 107, 240, 0.15);
}

.sub-title {
    font-size: 16px;
    opacity: 0.8;
    line-height: 1.6;
}

.login-form {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.login-tip {
    text-align: center;
    margin-bottom: 20px;
    font-size: 16px;
    font-weight: 500;
    color: #0F172A;
}

.activation-code {
    width: 100%;
    height: 48px;
    border-radius: 8px;
    font-size: 16px;
    margin-bottom: 25px;
}

.submit-btn {
    background: linear-gradient(to right, #246BF0, #3B82F6);
    border: none;
    width: 100%;
    height: 48px;
    border-radius: 8px;
    font-weight: 600;
    font-size: 16px;
    box-shadow: 0 6px 12px rgba(36, 107, 240, 0.25);
    transition: all 0.3s ease;
}

.submit-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 16px rgba(36, 107, 240, 0.35);
}

.login-status {
    text-align: center;
    padding: 30px 0;
}

.login-icon {
    width: 70px;
    height: 70px;
    margin: 20px auto;
    display: block;
}

.login-desc {
    font-size: 18px;
    font-weight: 500;
    margin-top: 20px;
}

.rotating {
    animation: rotate 2s linear infinite;
}

@keyframes rotate {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}

@keyframes slideUp {
    from {
        opacity: 0;
        transform: translateY(30px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}
</style>